module.exports = __webpack_public_path__ + "static/clothing-loafer-5c4805a159f979a0fee43c441395bb00.jpg";